import { Component } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';

@Component({
  template: `
    <ion-list>
      <ion-item (click)="close('https://arsahosting.com')"><ion-label>Sitio Web</ion-label></ion-item>
      <ion-item (click)="close('mailto:arsa@arsahosting.com')"><ion-label>Correo Electrónico</ion-label></ion-item>
    </ion-list>
  `
})
export class PopoverPage {

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController
  ) { }

  support() {
    // this.app.getRootNav().push('SupportPage');
    this.modalCtrl.dismiss();
  }

  close(url: string) {
    window.open(url, '_blank');
    this.modalCtrl.dismiss();
  }
}